import { CustomerRepository } from "../../../../data/repository/customer/CustomerRepository";
import { Customer } from "../../../model/Customer";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetCustomerByIdUseCase {
  invoke: (id: string) => Promise<ResponseState<Customer>>;
}

export class GetCustomerByIdUseCaseImpl implements GetCustomerByIdUseCase {
  private repository: CustomerRepository;

  constructor(repository: CustomerRepository) {
    this.repository = repository;
  }

  async invoke(id: string): Promise<ResponseState<Customer>> {
    try {
      let response = await this.repository.getById(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
